import React from "react";

import Button from "../Button";
import { BiMapPin } from "react-icons/bi";
import { CiSettings } from "react-icons/ci";
import { FiAlertCircle } from "react-icons/fi";

const LocationPermissionInstructions = () => {
  const getBrowserInstructions = () => {
    const userAgent = navigator.userAgent;

    if (userAgent.includes("Chrome")) {
      return {
        browser: "Chrome",
        steps: [
          "Click the location icon in the address bar",
          'Select "Allow" for location access',
          "Refresh the page",
        ],
      };
    } else if (userAgent.includes("Firefox")) {
      return {
        browser: "Firefox",
        steps: [
          "Click the shield icon in the address bar",
          'Click "Allow Location Access"',
          "Refresh the page",
        ],
      };
    } else if (userAgent.includes("Safari")) {
      return {
        browser: "Safari",
        steps: [
          "Go to Safari → Preferences → Websites → Location",
          'Find this website and set it to "Allow"',
          "Refresh the page",
        ],
      };
    } else {
      return {
        browser: "your browser",
        steps: [
          "Look for a location/lock icon in your address bar",
          "Click it and allow location access",
          "Refresh the page",
        ],
      };
    }
  };

  const { browser, steps } = getBrowserInstructions();

  return (
    <div className="mx-auto rounded-lg ">
      <div className="flex items-center gap-3 mb-4">
        <FiAlertCircle className="text-primary" size={24} />
        <h3 className="text-lg font-semibold text-gray-800">
          Location Access Required
        </h3>
      </div>

      <p className="text-gray-600 mb-4">
        We need your location to calculate delivery distances and costs.
        Location access was previously denied.
      </p>

      <div className="mb-4">
        <h4 className="font-medium text-gray-800 mb-2 flex items-center gap-2">
          <CiSettings size={16} />
          How to enable location in {browser}:
        </h4>
        <ol className="list-decimal list-inside space-y-1 text-sm text-gray-600">
          {steps.map((step, index) => (
            <li key={index}>{step}</li>
          ))}
        </ol>
      </div>

      <div className="flex justify-center">
        <Button className="flex-1 md:flex-none w-full md:max-w-max px-2 min-h-0 h-8 md:h-10 " onClick={() => window.location.reload()}>
          <BiMapPin size={16} />
          Refresh Page After Enabling
        </Button>
      </div>

      <p className="text-xs text-gray-500 mt-3 text-center">
        Your location is only used for this service and is not stored
        permanently.
      </p>
    </div>
  );
};

export default LocationPermissionInstructions;
